import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import {makeStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';



const useStyles = makeStyles(theme => ({
  back: {
    'background-image': `url(${process.env.PUBLIC_URL}/images/2.png)`,
    'background-repeat': 'no-repeat',
    'background-size': 'cover',
    height: '100vh',
    'background-position': 'bottom',
    overflow: 'hidden'

  },
  head: {
    textAlign: 'center',
    textDecoration: 'none',
    paddingTop: '20%',
    [theme.breakpoints.down('md')]: {
      paddingTop: '70%',
    }

  },
  button: {
    margin: '10px',

  },
  h1: {
    fontSize: '10vh',
    color: '#2e2f32',
    margin: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '42px',
    }
  }
}));


function Home() {

  const classes = useStyles();


    return (

        <div
          className={classes.back}
          >
          <div
            className={classes.head}>
            <h1
              className={classes.h1}>
              MARKETING TOOLS APP
            </h1>
            <Link
              to={'/signin'}
              style={{textDecoration: 'none'}}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                style={{
                  background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}>
                sign in
              </Button>
            </Link>
            <Link
              to={'/register'}
              style={{textDecoration: 'none'}}>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                style={{
                  background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}>
                Register
              </Button>
            </Link>
          </div>
        </div>
    )
}

const mapStateToProps = state => state.project;
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(Home)
